import React, { Dispatch } from 'react';
import { MoveType } from '../types/MoveType';
import { GameMoveModel } from '../types/GamesModel';
import { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { getIcon } from '../utils/ChessTypes';
import Empty from '../assets/empty.svg';

export default function GamesMoveTypes(props: {
  move: GameMoveModel;
  showList: boolean;
  moveType: MoveType | undefined;
  setMoveType: Dispatch<React.SetStateAction<MoveType | undefined>>;
}): React.ReactNode {
  const { move, showList, moveType, setMoveType } = props;
  const [show, setShow] = useState(false);
  const evaluation = `Evaluation: ${move.Evaluation} | Delta: ${move.Delta}`;
  const MyIcon = getIcon(moveType);
  return (
    <span className="d-flex flex-row" title={evaluation}>
      <MyIcon className="mt-1 me-1" />
      {showList ? (
        <Dropdown
          className="me-2"
          onClick={(e) => {
            e.stopPropagation();
            setShow(!show);
          }}
        >
          <Dropdown.Toggle as="a" className="pointer cm-type-toggle"></Dropdown.Toggle>
          <Dropdown.Menu show={show}>
            <Dropdown.Item href="#/">
              <Empty className="me-1" />
              <span>None</span>
            </Dropdown.Item>
            {Object.values(MoveType)
              .filter((m) => typeof m !== 'string')
              .map((m: MoveType, i) => {
                const boldClass1 = moveType == m ? 'fw-bold' : '';
                const mStr = m != null ? MoveType[m] : null;
                const Icon = getIcon(m);
                return (
                  <Dropdown.Item
                    key={i}
                    className={boldClass1}
                    onClick={() => (setMoveType ? setMoveType(m) : null)}
                  >
                    <Icon className="me-1" />
                    <span>{mStr}</span>
                  </Dropdown.Item>
                );
              })}
          </Dropdown.Menu>
        </Dropdown>
      ) : null}
    </span>
  );
}
